export default "__VITE_ASSET__BAgIZBRJ__"